import { apiUrl } from '../settings';
import { getDefaultLanguage } from '../settings/i18n/i18n';
import StorageManager from '../helpers/storageManager';

type HeaderType = 'json' | 'csv';
type BaseType = (url: string, data?: unknown, type?: HeaderType) => Promise<Response>;
type AbortBaseType = (url: string, signal: AbortSignal, data?: unknown, type?: HeaderType) => Promise<Response>;
type Method = 'get' | 'post' | 'put' | 'delete';

type SuperFetchType = Record<Method, BaseType>;
type AbortSuperFetchType = Record<Method, AbortBaseType>;

const customFetch = (method: Method, url: string, signal: AbortSignal | undefined, data: unknown, type = 'json') => {
  const safeApiUrl = apiUrl[apiUrl.length - 1] === '/' ? apiUrl.slice(0, apiUrl.length - 1) : apiUrl;
  return fetch(`${safeApiUrl}/${url}`, {
    method,
    headers: {
      'Content-Type': type === 'csv' ? 'text/csv' : 'application/json',
      Accept: type === 'csv' ? 'text/csv' : 'application/json',
      Authorization: `Bearer ${StorageManager.get('id_token')}`,
      AuthorizationR: `${StorageManager.get('refresh_token')}`,
      'Accept-Language': getDefaultLanguage(),
    },
    signal,
    body: method === 'post' || method === 'put' || method === 'delete' ? JSON.stringify(data) : null,
  })
    .then(response => {
      const contentTypes = response.headers.get('content-type');
      if (contentTypes && (contentTypes.includes('application/pdf') || contentTypes.includes('csv'))) return response.blob();
      else return response.json();
    })
    .then(response => {
      if (response.status === 'success' || response instanceof Blob) {
        return response;
      } else throw response;
    })
    .catch(response => {
      throw response;
    });
};

const abortBase = (method: Method, url: string, signal: AbortSignal, data: unknown | undefined = {}, type?: HeaderType) =>
  customFetch(method, url, signal, data, type);

const base = (method: Method, url: string, data: unknown | undefined = {}, type?: HeaderType) =>
  customFetch(method, url, undefined, data, type);

const SuperFetch = {} as SuperFetchType;
const AbortSuperFetch = {} as AbortSuperFetchType;
['get', 'post', 'put', 'delete'].forEach(method => {
  SuperFetch[method as Method] = base.bind(null, method as Method);
  AbortSuperFetch[method as Method] = abortBase.bind(null, method as Method);
});

export { SuperFetch, AbortSuperFetch };
export default SuperFetch;
